<template>
  <div class="user-reviews">
    <div class="user-reviews__header">
      <div class="user-reviews__title-wrapper">
        <div class="user-reviews__title">User Reviews</div>
      </div>
      <div class="user-reviews__controls">
        <div class="user-reviews__control user-reviews__control--prev"
          :class="{ 'user-reviews__control--disabled': !hasPrev }" @click="prevSlide">
          <svg xmlns="http://www.w3.org/2000/svg" class="user-reviews__control-arrow" width="6"
            height="12" viewBox="0 0 6 12" fill="none">
            <path
              d="M1.56641 6.00382L5.79139 1.35876C5.9351 1.20076 6.00456 1.0138 5.99977 0.797876C5.99498 0.581949 5.92073 0.394988 5.77702 0.236993C5.63332 0.0789977 5.46326 0 5.26686 0C5.07046 0 4.90041 0.0789977 4.7567 0.236993L0.344896 5.10325C0.229931 5.22965 0.143707 5.37184 0.0862241 5.52984C0.0287414 5.68783 0 5.84583 0 6.00382C0 6.16182 0.0287414 6.31981 0.0862241 6.47781C0.143707 6.6358 0.229931 6.778 0.344896 6.9044L4.77107 11.7707C4.91478 11.9286 5.08244 12.005 5.27405 11.9997C5.46566 11.9945 5.63332 11.9128 5.77702 11.7549C5.92073 11.5969 5.99258 11.4099 5.99258 11.194C5.99258 10.978 5.92073 10.7911 5.77702 10.6331L1.56641 6.00382Z"
              fill="white" />
          </svg>
        </div>
        <div class="user-reviews__control user-reviews__control--next"
          :class="{ 'user-reviews__control--disabled': !hasNext }" @click="nextSlide">
          <svg xmlns="http://www.w3.org/2000/svg" class="user-reviews__control-arrow"
            viewBox="0 0 6 12" fill="none">
            <path
              d="M4.43359 6.00382L0.208607 1.35876C0.0649 1.20076 -0.00455845 1.0138 0.000231786 0.797876C0.00502202 0.581949 0.0792707 0.394988 0.222978 0.236993C0.366685 0.0789977 0.536738 0 0.733138 0C0.929537 0 1.09959 0.0789977 1.2433 0.236993L5.6551 5.10325C5.77007 5.22965 5.85629 5.37184 5.91378 5.52984C5.97126 5.68783 6 5.84583 6 6.00382C6 6.16182 5.97126 6.31981 5.91378 6.47781C5.85629 6.6358 5.77007 6.778 5.6551 6.9044L1.22893 11.7707C1.08522 11.9286 0.917562 12.005 0.725952 11.9997C0.534343 11.9945 0.366685 11.9128 0.222978 11.7549C0.0792707 11.5969 0.00741714 11.4099 0.00741714 11.194C0.00741714 10.978 0.0792707 10.7911 0.222978 10.6331L4.43359 6.00382Z"
              fill="white" />
          </svg>
        </div>
      </div>
    </div>
    <div class="user-reviews__slider">
      <div class="user-reviews__slider-container" ref="sliderContainer">
        <div v-for="(review, index) in reviews" :key="index" class="user-reviews__card">
          <div class="user-reviews__card-title">{{ review.title }}</div>
          <div class="user-reviews__card-author">
            <div class="user-reviews__author-name">{{ review.author }}</div>
            <div class="user-reviews__card-separator"></div>
            <div class="user-reviews__card-date">{{ review.date }}</div>
          </div>
          <div class="user-reviews__card-text">
            {{ review.text }}
            <span v-if="review.showReadMore" class="user-reviews__read-more"
              @click="openPopup(review)">Read More</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗 -->
    <div class="user-reviews__popup" v-if="showPopup" @click.self="closePopup">
      <div class="user-reviews__popup-content">
        <div class="user-reviews__popup-title">{{ activeReview.title }}</div>
        <div class="user-reviews__popup-author">
          <div class="user-reviews__popup-author-name">{{ activeReview.author }}</div>
          <div class="user-reviews__popup-separator"></div>
          <div class="user-reviews__popup-date">{{ activeReview.date }}</div>
        </div>
        <div class="user-reviews__popup-text">{{ activeReview.fullText || activeReview.text }}</div>
        <div class="user-reviews__popup-close" @click="closePopup">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14"
            fill="none">
            <path
              d="M7 8.49049L1.78327 13.7072C1.58809 13.9024 1.33967 14 1.03802 14C0.736375 14 0.487959 13.9024 0.292776 13.7072C0.0975919 13.512 0 13.2636 0 12.962C0 12.6603 0.0975919 12.4119 0.292776 12.2167L5.50951 7L0.292776 1.78327C0.0975919 1.58809 0 1.33967 0 1.03802C0 0.736375 0.0975919 0.487959 0.292776 0.292776C0.487959 0.0975919 0.736375 0 1.03802 0C1.33967 0 1.58809 0.0975919 1.78327 0.292776L7 5.50951L12.2167 0.292776C12.4119 0.0975919 12.6603 0 12.962 0C13.2636 0 13.512 0.0975919 13.7072 0.292776C13.9024 0.487959 14 0.736375 14 1.03802C14 1.33967 13.9024 1.58809 13.7072 1.78327L8.49049 7L13.7072 12.2167C13.9024 12.4119 14 12.6603 14 12.962C14 13.2636 13.9024 13.512 13.7072 13.7072C13.512 13.9024 13.2636 14 12.962 14C12.6603 14 12.4119 13.9024 12.2167 13.7072L7 8.49049Z"
              fill="#FE324B" />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserReviews',
  props: {
    reviews: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      currentIndex: 0,
      visibleItems: 3,
      totalItems: 0,
      showPopup: false,
      activeReview: {}
    };
  },
  computed: {
    hasPrev () {
      return this.currentIndex > 0;
    },
    hasNext () {
      return this.currentIndex + this.visibleItems < this.totalItems;
    }
  },
  watch: {
    reviews: {
      immediate: true,
      handler (newVal) {
        this.totalItems = newVal.length;
      }
    }
  },
  methods: {
    prevSlide () {
      if (this.hasPrev) {
        this.currentIndex--;
        this.scrollSlider();
      }
    },
    nextSlide () {
      if (this.hasNext) {
        const container = this.$refs.sliderContainer;
        if (container) {
          const cardWidth = container.querySelector('.user-reviews__card').offsetWidth;
          const gapWidth = parseInt(window.getComputedStyle(container).getPropertyValue('gap'));
          const sliderWidth = this.$el.querySelector('.user-reviews__slider').offsetWidth;

          // 如果是最后几个元素，确保显示到最后一个
          if (this.currentIndex + this.visibleItems + 1 >= this.totalItems) {
            // 计算可以显示的最大索引，确保最后一个卡片完全可见
            const maxIndex = this.totalItems - Math.floor(sliderWidth / (cardWidth + gapWidth));
            this.currentIndex = Math.max(0, maxIndex);
          } else {
            this.currentIndex++;
          }
          this.scrollSlider();
        }
      }
    },
    scrollSlider () {
      const container = this.$refs.sliderContainer;
      if (container) {
        const cardWidth = container.querySelector('.user-reviews__card').offsetWidth;
        const gapWidth = parseInt(window.getComputedStyle(container).getPropertyValue('gap'));

        // 获取左侧padding值
        const sliderElement = this.$el.querySelector('.user-reviews__slider');
        const leftPadding = parseInt(window.getComputedStyle(sliderElement).getPropertyValue('padding-left'));

        let translateX = 0;
        if (this.currentIndex === 0) {
          // 第一个位置，不需要偏移
          translateX = 0;
        } else if (this.currentIndex === 1) {
          // 第一次滚动，需要考虑左侧padding
          translateX = cardWidth + gapWidth;
        } else {
          // 后续滚动，考虑卡片和间距
          translateX = this.currentIndex * (cardWidth + gapWidth);
        }

        container.style.transform = `translateX(-${translateX}px)`;
      }
    },
    openPopup (review) {
      this.activeReview = review;
      this.showPopup = true;
      // 禁用背景滚动
      document.body.style.overflow = 'hidden';
    },
    closePopup () {
      this.showPopup = false;
      // 恢复背景滚动
      document.body.style.overflow = '';
    }
  }
};
</script>

<style lang="scss">
@import '@/css/variables.scss';

.user-reviews {
	display: flex;
	flex-direction: column;
	gap: rem(24);
	align-items: flex-start;
	justify-content: flex-start;
	align-self: stretch;
	position: relative;
	width: 100%;

	&__header {
		padding: 0 rem(80);
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		align-self: stretch;
		position: relative;
		width: 100%;
	}

	&__title-wrapper {
		display: flex;
		flex-direction: row;
		gap: rem(24);
		align-items: center;
		justify-content: flex-start;
		position: relative;
	}

	&__title {
		color: #ffffff;
		text-align: left;
		font-size: rem(24);
		line-height: rem(24);
		font-weight: 900;
		position: relative;
	}

	&__more {
		display: flex;
		flex-direction: row;
		gap: rem(12);
		align-items: center;
		justify-content: flex-start;
		position: relative;
		cursor: pointer;
	}

	&__more-text {
		color: #fe324b;
		text-align: left;
		font-size: rem(14);
		line-height: rem(14);
		font-weight: 400;
		position: relative;
	}

	&__more-icon {
		width: rem(16);
		height: rem(12);
		position: relative;
	}

	&__more-arrow {
		width: 100%;
		overflow: visible;
	}

	&__controls {
		display: flex;
		flex-direction: row;
		gap: rem(20);
		align-items: flex-start;
		justify-content: flex-end;
		position: relative;
	}

	&__control {
		width: rem(28);
		height: rem(28);
		position: relative;
		cursor: pointer;

		&::before {
			content: '';
			background: #ffffff;
			border-radius: 100px;
			opacity: 0.1;
			width: rem(28);
			height: rem(28);
			position: absolute;
			left: 0;
			top: 0;
		}

		&--disabled {
			opacity: 0.5;
			cursor: default;
		}
	}

	&__control-arrow {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: rem(6);
		height: rem(12);
	}

	&__slider {
		padding: 0 0 0 rem(80);
		width: 100%;
		overflow: hidden;
		position: relative;
	}

	&__slider-container {
		display: flex;
		flex-direction: row;
		gap: rem(20);
		align-items: flex-start;
		justify-content: flex-start;
		transition: transform 0.3s ease;
		padding-right: rem(80);
	}

	&__card {
		background: rgba(255, 255, 255, 0.1);
		border-radius: rem(16);
		padding: rem(32);
		display: flex;
		flex-direction: column;
		gap: rem(12);
		align-items: flex-start;
		justify-content: flex-start;
		width: rem(320);
		height: rem(252);
		position: relative;
		flex-shrink: 0;
	}

	&__card-title {
		color: #ffffff;
		text-align: left;
		font-size: rem(20);
		line-height: rem(24);
		font-weight: 700;
		position: relative;
		align-self: stretch;
	}

	&__card-author {
		display: flex;
		flex-direction: row;
		gap: rem(12);
		align-items: center;
		justify-content: flex-start;
		position: relative;
	}

	&__author-name {
		color: #ffffff;
		text-align: left;
		font-size: rem(14);
		line-height: rem(14);
		font-weight: 400;
		opacity: 0.4;
		position: relative;
	}

	&__card-separator {
		background: #ffffff;
		opacity: 0.1;
		width: rem(1);
		height: rem(20);
		position: relative;
	}

	&__card-date {
		color: #ffffff;
		text-align: left;
		font-size: rem(14);
		line-height: rem(14);
		font-weight: 400;
		position: relative;
	}

	&__card-text {
		color: rgba(255, 255, 255, 0.6);
		text-align: left;
		font-size: rem(14);
		line-height: rem(20);
		font-weight: 400;
		position: relative;
		align-self: stretch;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 7;
		-webkit-box-orient: vertical;
	}

	&__read-more {
		color: #fe324b;
		cursor: pointer;
		margin-left: rem(5);
	}

	// 弹窗样式
	&__popup {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.8);
		z-index: 1000;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	&__popup-content {
		background: linear-gradient(180deg, rgba(13, 12, 15, 1) 0%, rgba(42, 40, 46, 1) 100%);
		border-radius: rem(16);
		border: 1px solid rgba(255, 255, 255, 0.2);
		padding: rem(32);
		display: flex;
		flex-direction: column;
		gap: rem(12);
		align-items: flex-start;
		justify-content: flex-start;
		width: rem(680);
		position: relative;
		max-height: 65%;
		overflow: auto;
		scrollbar-width: thin; /* Firefox */
		-ms-overflow-style: none; /* IE and Edge */
		scroll-behavior: smooth;
		scrollbar-color: rgba(#fff, 0.5) rgba(42, 40, 46, 1);
	}

	&__popup-title {
		color: #ffffff;
		text-align: left;
		font-size: rem(20);
		line-height: rem(24);
		font-weight: 700;
		position: relative;
		align-self: stretch;
	}

	&__popup-author {
		display: flex;
		flex-direction: row;
		gap: rem(12);
		align-items: center;
		justify-content: flex-start;
		position: relative;
	}

	&__popup-author-name {
		color: #ffffff;
		text-align: left;
		font-size: rem(14);
		line-height: rem(14);
		font-weight: 400;
		opacity: 0.4;
		position: relative;
	}

	&__popup-separator {
		background: #ffffff;
		opacity: 0.1;
		width: rem(1);
		height: rem(20);
		position: relative;
	}

	&__popup-date {
		color: #ffffff;
		text-align: left;
		font-size: rem(14);
		line-height: rem(14);
		font-weight: 400;
		position: relative;
	}

	&__popup-text {
		color: rgba(255, 255, 255, 0.6);
		text-align: left;
		font-size: rem(14);
		line-height: rem(20);
		font-weight: 400;
		position: relative;
		align-self: stretch;
	}

	&__popup-close {
		position: absolute;
		right: rem(16);
		top: rem(16);
		width: rem(14);
		height: rem(14);
		cursor: pointer;
		svg {
			display: block;
		}
	}
}

// PC端基础样式
.detect_deviece_pc,
.detect_deviece_desktop {
	.user-reviews {
		// PC端特定样式
	}
}

// 移动端基础样式
.detect_deviece_mobile {
	.user-reviews {
		padding: 0 0 rem(30) 0;

		&__header {
			padding: 0 rem(16);
			flex-direction: column;
			align-items: flex-start;
		}

		&__title-wrapper {
			flex-direction: column;
			align-items: flex-start;
			gap: rem(16);
			width: 100%;
		}

		&__controls {
			display: none;
		}

		&__slider {
			padding: 0 0 0 rem(16);
			overflow-x: auto;
			-webkit-overflow-scrolling: touch;
			scrollbar-width: none;

			&::-webkit-scrollbar {
				display: none;
			}
		}

		&__card {
			width: rem(280);
			height: auto;
			min-height: rem(180);
		}

		&__popup-content {
			width: 90%;
			max-width: rem(350);
		}
	}
}
</style> 